import { useState } from "react";

export type PasswordFieldName = "password" | "oldPassword" | "newPassword";

const DEFAULT_VISIBILITY: Record<PasswordFieldName, boolean> = {
  password: false,
  oldPassword: false,
  newPassword: false,
};

export const useChangeEmailPassword = () => {
  const [visiblePasswordFields, setVisiblePasswordFields] = useState(
    DEFAULT_VISIBILITY
  );

  const togglePasswordVisibility = (field: PasswordFieldName) => {
    setVisiblePasswordFields((prev) => ({ ...prev, [field]: !prev[field] }));
  };

  return { visiblePasswordFields, togglePasswordVisibility };
};
